import { useState } from "react"
import './styles/registration.scss'
import { TextField, Alert, InputLabel, MenuItem, FormControl, Select } from '@mui/material';
import axios from "axios";
import { useNavigate } from "react-router-dom";

let style={
  width: "50%",
  '@media(max-width: 780px)' : {
    width: '80%'
  }
}


export default function Form() {
  const navigate = useNavigate();
  const [protege, setProtege] = useState("");
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  // const url = 'http://localhost:3999';
  const url = 'https://dev.pmwwebdesign.com'
  // Alert
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('');
  const [showAlert, setShowAlert] = useState(false);

  const handleApply = () => {
    const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
    const phoneRegex = /^[0-9]*$/

    if (firstName === "" || lastName === "" || phone === "" || email === "" || protege === "") {
      setMessage('All fields are required')
      setSeverity('warning')
      setShowAlert(true)
      setTimeout(() => {
        setShowAlert(false)
      }, 2000)
    } else if (!email.match(regex)) {
      setMessage('Email is the wrong format')
      setSeverity('warning')
      setShowAlert(true)
      setTimeout(() => {
        setShowAlert(false)
      }, 2000)
    } else if (!phone.match(phoneRegex)) {
      setMessage('Please insert your phone with only numbers')
      setSeverity('warning')
      setShowAlert(true)
      setTimeout(() => {
        setShowAlert(false)
      }, 2000)
    } else {
      let data = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: phone,
      }

      axios.post(`${url}/property/thity-day`, data)
        .then((res) => {
          navigate(`/thank-you`)
        }).catch((err) => {
          console.log(err)
          setMessage('something went wrong, please try again')
          setSeverity('error')
          setShowAlert(true)
          setTimeout(() => {
            setShowAlert(false)
          }, 2000)
        })
    }
  }


  return (
    <main className="registration__main">
      <h2>Join the challenge today</h2>
      {protege != "YES" ? (
        <h3><span>VERY IMPORTANT NOTE:</span> Make sure to use your correct name, email, and phone number to be approved for the private 30-Day Challenge Whatsapp Group. If your details are incorrect, you won’t get access and will miss out on the challenge.</h3>
      ) : null}
      <FormControl sx={style}>
        <InputLabel id="demo-simple-select-label">Are You An Active Protege Client?</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={protege}
          label="Age"
          onChange={(e) => setProtege(e.target.value)}
        >
          <MenuItem value="YES">YES</MenuItem>
          <MenuItem value="NO">NO</MenuItem>
        </Select>
      </FormControl>

      {protege === "YES" ? (
        <h4 className="protege__client">As a client, you're welcome to join the Protege Challenge. This challenge is for beginners and not for Protege-level clients, who have their own separate challenge.</h4>
      ) : (
        <section className="form">
          <section className="form__row">
            <TextField id="outlined-basic" label="First Name" variant="outlined" className='field' onChange={(e) => setFirstName(e.target.value)} required />
            <TextField id="outlined-basic" label="Last Name" variant="outlined" className='field' onChange={(e) => setLastName(e.target.value)} required />
          </section>
          <section className="form__row">
            <TextField id="outlined-basic" label="Email" variant="outlined" className='field' onChange={(e) => setEmail(e.target.value)} required />
            <TextField id="outlined-basic" label="Phone Number" variant="outlined" className='field' onChange={(e) => setPhone(e.target.value)} pattern='[0-9]*' required />
          </section>
          {showAlert ? (
            <Alert severity={severity} width="80%" >{message}</Alert>
          ) : (
            <button onClick={handleApply}>Join Now</button>
          )}
          <h3><span>Next Steps:</span> After joining by submitting the right details, you’ll get an email with the next steps to get ready for the challenge and info on joining the private Whatsapp group. Get excited, it’s going to be so much fun!</h3>
        </section>
      )}



    </main>
  )
}